export default {
  diagnostics: {
    READ_DIAGNOSTICS: {
      name: "Dostęp do narzędzi diagnostycznych",
      danger: true,
      desc:
        "Wykonywanie zapytań diagnostycznych do serwera,<br />pobieranie informacji serwisowych.<br /><strong>Uwaga:</strong> niniejsze uprawnienie umożliwia dostęp do wewnętrznej<br />infrastruktury systemu."
    }
  },

  administration: {
    READ_STATISTICS: { name: "Dostęp do statystyk i historii zdarzeń" },
    READ_USERS: { name: "Dostęp do listy użytkowników" },
    CREATE_USER: {
      name: "Tworzenie nowych użytkowników i przyznawanie uprawnień",
      danger: true,
      desc:
        "<strong>Uwaga:</strong> niniejsze uprawnienie umożliwia <br />utworzenie nowego użytkownika o dowolnych uprawnieniach,<br />co w skrajnym przypadku może prowadzić do eskalacji uprawnień."
    },
    UPDATE_USER: {
      name: "Aktualizacja użytkowników i przyznawanie uprawnień",
      danger: true,
      desc:
        "<strong>Uwaga:</strong> niniejsze uprawnienie umożliwia swobodne przyznawanie<br />i odwoływanie uprawnień, co w skrajnym przypadku<br />może prowadzić do eskalacji uprawnień."
    },
    DELETE_USER: { name: "Usuwanie użytkowników", danger: true }
  },

  messages: {
    CREATE_MESSAGE: { name: "Tworzenie nowych ogłoszeń" },
    UPDATE_MESSAGE: { name: "Aktualizacja ogłoszeń" },
    DELETE_MESSAGE: { name: "Usuwanie ogłoszeń" }
  },

  program: {
    CREATE_PROGRAM_BLOCK: { name: "Tworzenie nowych bloków programowych" },
    UPDATE_PROGRAM_BLOCK: { name: "Aktualizacja bloków programowych" },
    DELETE_PROGRAM_BLOCK: { name: "Usuwanie bloków programowych" },
    CREATE_PROGRAM_ITEM: { name: "Tworzenie nowych punktów programu" },
    UPDATE_PROGRAM_ITEM: { name: "Aktualizacja punktów programu" },
    DELETE_PROGRAM_ITEM: { name: "Usuwanie punktów programu" }
  },

  static: {
    CREATE_TEMPLATE: {
      name: "Aktualizacja statycznych treści",
      desc:
        "Aktualizacja opisów ofert TV i Internetu,<br />informacji kontaktowych, polityki prywatności,<br />informacji RODO, treści stopki etc."
    }
  },

  videos: {
    CREATE_TAG: { name: "Tworzenie nowych tagów" },
    UPDATE_TAG: { name: "Aktualizacja tagów" },
    DELETE_TAG: { name: "Usuwanie tagów" },
    CREATE_VIDEO: {
      name: "Tworzenie nowych filmów",
      desc:
        "<strong>Uwaga:</strong> operacja tworzenia nowych materiałów filmowych wymaga również<br />przyznanego uprawnienia dostępu do listy plików źródłowych."
    },
    UPDATE_VIDEO: { name: "Aktualizacja filmów" },
    DELETE_VIDEO: { name: "Usuwanie filmów" },
    READ_VIDEO_SOURCES: { name: "Dostęp do listy plików źródłowych" }
  }
};
